/**
 * Centralized property constants for the frontend.
 * 
 * This module contains all property-related constants used throughout the frontend application.
 * Use these constants instead of hardcoding values to ensure consistency
 * and make future changes easier.
 * 
 */

export const TransactionType = {
  FOR_SALE: "For Sale",
  FOR_LEASE: "For Lease",
  FOR_SUB_LEASE: "For Sub-Lease"
};

export const StandardStatus = {
  DRAFT: "Draft",
  MLS_READY: "MLS Ready",
  ACTIVE: "Active",
  SOLD: "Sold",
  TERMINATED: "Terminated",
  EXPIRED: "Expired"
};

// export const PropertySubType =
// {
//     'Condo Apartment', 'Detached', 'Semi-Detached', 'Att/Row/Townhouse', 'Co-op Apartment', 'Co-Ownership Apartment',
//     'Commercial Retail', 'Common Element Condo',  'Condo Townhouse', 'Detached Condo', 'Duplex', 'Farm', 'Fourplex',
//     'Industrial', 'Investment', 'Land', 'Leasehold Condo', 'Link', 'Locker', 'Lower Level', 'MobileTrailer', 'Modular Home',
//     'Multiplex', 'Office', 'Other', 'Parking Space', 'Phased Condo', 'Room', 'Rural Residential', 'Sale Of Business', 
//     'Semi-Detached Condo', 'Shared Room', 'Store W Apt/Office', 'Timeshare', 'Triplex', 'Upper Level', 'Vacant Land', 'Vacant Land Condo'
// }

/**
 * Centralized color scheme for property StandardStatus badges.
 * Each status maps to { bgcolor, color } for consistent styling.
 * Change colors here — every badge across the app updates automatically.
 */
export const STATUS_COLORS = {
  [StandardStatus.ACTIVE]:     { bgcolor: '#dcfce7', color: '#15803d' },
  [StandardStatus.MLS_READY]:  { bgcolor: '#dbeafe', color: '#1d4ed8' },
  [StandardStatus.SOLD]:       { bgcolor: '#fecaca', color: '#dc2626' },
  [StandardStatus.TERMINATED]: { bgcolor: '#fee2e2', color: '#991b1b' },
  [StandardStatus.EXPIRED]:    { bgcolor: '#fef3c7', color: '#a16207' },
  [StandardStatus.DRAFT]:      { bgcolor: '#fff3cd', color: '#475569' },
};

/** Default fallback colors when status is unknown */
const DEFAULT_STATUS_COLOR = { bgcolor: '#fff3cd', color: '#475569' };

/**
 * Get colors for a given StandardStatus value.
 * @param {string} status — e.g. 'Active', 'Sold', 'Draft'
 * @returns {{ bgcolor: string, color: string }}
 */
export const getStatusColors = (status) =>
  STATUS_COLORS[status] || DEFAULT_STATUS_COLOR;


export const DEMOGRAPHIC_CHART_COLORS = [
  '#2f6f8d',
  '#2ca58d',
  '#f59e0b',
  '#ef4444',
  '#6366f1',
  '#74b876',
  '#8b5cf6',
  '#f97316',
  '#008971',
  '#e11d48',
  '#0ea5e9',
  '#a3a3a3',
  '#84cc16',
  '#c99776',
];


export default { TransactionType, StandardStatus, STATUS_COLORS, getStatusColors, DEMOGRAPHIC_CHART_COLORS };